export const recentBuyers = [
  { name: 'Carolina', city: 'Palermo, CABA' },
  { name: 'Mariana', city: 'La Plata, Buenos Aires' },
  { name: 'Sofía', city: 'Rosario, Santa Fe' },
  { name: 'Florencia', city: 'Córdoba Capital' },
  { name: 'Agustina', city: 'Mendoza' },
  { name: 'Paula', city: 'Mar del Plata, Buenos Aires' },
  { name: 'Julieta', city: 'San Miguel de Tucumán' },
  { name: 'Natalia', city: 'Salta' },
  { name: 'Gabriela', city: 'Neuquén' },
  { name: 'Daniela', city: 'Quilmes, Buenos Aires' },
  { name: 'Lorena', city: 'Santa Fe Capital' },
  { name: 'Verónica', city: 'Bahía Blanca, Buenos Aires' },
  { name: 'Melina', city: 'Posadas, Misiones' },
  { name: 'Cecilia', city: 'San Juan' },
  { name: 'Romina', city: 'Paraná, Entre Ríos' },
  { name: 'Silvina', city: 'Bariloche, Río Negro' },
  { name: 'Andrea', city: 'Lomas de Zamora, Buenos Aires' },
  { name: 'Valeria', city: 'Villa Carlos Paz, Córdoba' },
];

export const purchasedPlans = ['Megapack Premium', 'Megapack Base'];
